import React, { useEffect, useState, useMemo } from 'react'
import cn from 'classnames'

import { useDropdown } from '@hooks/useDropdown'
import { ChevronDownIcon } from '@components/icons/ChevronDownIcon'
import { SelectSearchProps } from '../interfaces/SelectSearch'

export function SelectSearch({
  placeholder,
  className,
  disabled,
  value,
  options,
  name,
  onChange,
}: SelectSearchProps) {
  const [round, setRound] = useState(1)
  const [textSearch, setTextSearch] = useState('')
  const { dropdownRef, isShowDropdown, toggleDropdown } = useDropdown()

  useEffect(() => {
    if (!isShowDropdown) {
      setTextSearch(String(options?.find(o => o.value === value)?.text || ''))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShowDropdown])

  useEffect(() => {
    setTextSearch(String(options?.find(o => o.value === value)?.text || ''))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  const optionsFilter = useMemo(() => {
    setRound(1)

    if (!options?.length) {
      return []
    }

    if (!textSearch) {
      return options
    }

    return options.filter(option => {
      const text = String(option.text)
      return text.toLowerCase().includes(textSearch.toLowerCase().trim())
    })
  }, [options, textSearch])

  return (
    <div
      ref={dropdownRef}
      className={cn(
        'w-full font-light text-[14px] text-secondary dark:text-dark-10',
        className
      )}
    >
      <div
        className={cn(
          'flex items-center justify-between h-[40px] border-[1px] border-gray-3 dark:border-purple rounded-[8px] p-[10px] cursor-pointer dark:bg-dark-8',
          {
            'cursor-default pointer-events-none ': disabled,
            'border-primary': isShowDropdown,
          }
        )}
        onClick={toggleDropdown}
      >
        <input
          name={name}
          className={cn('w-full outline-none font-light dark:bg-dark-8', {
            'bg-white cursor-not-allowed': disabled,
          })}
          type='text'
          placeholder={placeholder}
          value={textSearch}
          onChange={e => setTextSearch(e.target.value)}
          disabled={disabled}
          autoComplete='off'
        />
        <ChevronDownIcon className='text-primary' width='16' height='16' />
      </div>
      <div
        className={cn(
          'absolute w-full z-10 mt-[5px] right-0 bg-white dark:bg-dark-8 border border-gray-4 dark:border-purple rounded-[10px] max-h-[400px] overflow-y-auto shadow-dropdown',
          { hidden: !options?.length || !isShowDropdown }
        )}
        onScroll={(e: any) => {
          const scrollHeight = e.target.scrollHeight - 10
          const scrollTop = e.target.scrollTop + e.target.offsetHeight

          if (
            scrollHeight <= scrollTop &&
            optionsFilter.length !== optionsFilter.slice(0, round * 10).length
          ) {
            setRound(prev => prev + 1)
          }
        }}
      >
        {optionsFilter.slice(0, round * 10).map((option, index) => (
          <div
            className='text-secondary dark:text-dark-10 py-[10px] px-[20px] hover:bg-primary-1 dark:hover:bg-dark hover:text-primary cursor-pointer'
            key={index}
            onClick={() => {
              if (onChange) onChange(option.value)
              toggleDropdown()
            }}
          >
            {option.text}
          </div>
        ))}
      </div>
    </div>
  )
}
